import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchBar({ searchText, setSearchText }) {
  return (
    <TextField
      size="small"
      label="Quick Search"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      sx={{ bgcolor: "white" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}
